import { css } from 'styled-components';

export default css`
  .icon {
    margin-right: 10px;
  }
`;
